import angular from 'angular'
import './edition/edition.controller'
import './collectibles.service'
import './shinies/shinies.controller'
import './shinies/shinies.service'
import './shinies/odds/odds.controller'
import './shinies/odds/odds.service'

angular
  .module('pub.collectibles', ['pub.collectibles.edition', 'pub.collectibles.service', 'pub.shinies'])
  .controller('CollectiblesCtrl', CollectiblesCtrl)

/** @ngInject */
function CollectiblesCtrl(
  $state,
  $q,
  $stateParams,
  $filter,
  $timeout,
  $sce,
  $rootScope,
  UploadService,
  SetsService,
  CollectiblesService,
) {
  var vm = this
  vm.model = {}
  vm.items = []
  vm.isFigurine = false
  vm.filter = 'Date: Newest'
  vm.sort = ['Date: Newest', 'Date: Oldest']

  vm.sortType = 'id'
  vm.sortReverse = false

  vm.sortBy = function () {
    switch (vm.filter) {
      case 'Date: Newest':
        break
      case 'Date: Oldest':
        break
    }
  }

  SetsService.getId($stateParams.parentId).then(function (result) {
    vm.set = result.results
    if (vm.set['k-prod'] === 3) {
      vm.isFigurine = true
      vm.nameType = 'Figure'
      $('.breadprogress-pagination p')[1].textContent = 'Figure'
    } else if (vm.set['k-prod'] === 2) {
      vm.isFigurine = false
      vm.nameType = 'Card'
      $('.breadprogress-pagination p')[1].textContent = 'Card'
    } else if (vm.set['k-prod'] === 1) {
      vm.isFigurine = false
      vm.nameType = 'Sticker'
      $('.breadprogress-pagination p')[1].textContent = 'Sticker'
    } else {
      vm.isFigurine = false
      vm.nameType = 'Card'
    }
    $('#breadcrumb a').last().after(vm.set.t)
  })

  vm.itemsDraft = []
  vm.itemsAwaitingCount = []

  function load() {
    vm.items = []
    vm.itemsDraft = []
    CollectiblesService.getSetId($stateParams.parentId).then(function (result) {
      vm.cr = 0
      for (var i = 0; i < result.results.length; i++) {
        result.results[i]['ts-m'] = new Date(
          parseInt(
            result.results[i]['ts-m']
              .toString()
              .substring(0, result.results[i]['ts-m'].toString().length - 3),
          ),
        )
        if (result.results[i]['ts-p'] !== undefined && result.results[i]['ts-p'] !== null) {
          result.results[i]['ts-p'] = new Date(
            parseInt(
              result.results[i]['ts-p']
                .toString()
                .substring(0, result.results[i]['ts-p'].toString().length - 3),
            ),
          )
        }

        if (result.results[i].st === 0) {
          result.results[i].status = 'Draft'
          vm.itemsDraft.push(result.results[i])
        } else if (result.results[i].st === 1) {
          result.results[i].status = 'Published'
        } else if (result.results[i].st === 2) {
          result.results[i].status = 'Sold Out'
        } else if (result.results[i].st === 3) {
          result.results[i].status = 'Unavailable'
        } else if (result.results[i].st === 4) {
          result.results[i].status = 'Awaiting Count'
          vm.itemsAwaitingCount.push(result.results[i])
        }

        vm.cr += result.results[i].cr

        if (result.results[i]['img-t'] && (result.results[i]['img-t'].indexOf('.mp4') !== -1 || result.results[i]['img-t'].indexOf('.mov') !== -1)) {
          result.results[i].isVideoT = true
          result.results[i].videoT = $sce.trustAsResourceUrl($rootScope.urlS3 + '/collectibles/' + result.results[i]['img-t'])
        } else {
          result.results[i].isVideoT = false
        }

        if (result.results[i]['img-l'] && (result.results[i]['img-l'].indexOf('.mp4') !== -1 || result.results[i]['img-l'].indexOf('.mov') !== -1)) {
          result.results[i].isVideoL = true
          result.results[i].videoL = $sce.trustAsResourceUrl($rootScope.urlS3 + '/collectibles/' + result.results[i]['img-l'])
        } else {
          result.results[i].isVideoL = false
        }

        if (result.results[i]['img-b-l'] && (result.results[i]['img-b-l'].indexOf('.mp4') !== -1 || result.results[i]['img-b-l'].indexOf('.mov') !== -1)) {
          result.results[i].isVideoBL = true
          result.results[i].videoBL = $sce.trustAsResourceUrl($rootScope.urlS3 + '/collectibles/' + result.results[i]['img-b-l'])
        } else {
          result.results[i].isVideoBL = false
        }

        result.results[i].edit = false
      }
      vm.items = result.results
    })
  }

  vm.create = function () {
    $state.go('pub.collectibles.create', { parentId: $stateParams.parentId })
  }

  vm.delete = function (id) {
    CollectiblesService.listTranslations(id).then(function (result) {
      vm.collectiblesTranslations = result.results
      swal(
        {
          title: 'Delete',
          text: 'You want to delete this collectible?',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            var promises = []
            for (var i = 0; i < vm.collectiblesTranslations.length; i++) {
              promises.push(CollectiblesService.removeTranslation(vm.collectiblesTranslations[i].id))
            }

            if (promises.length > 0) {
              $q.all(promises).then(function () {
                CollectiblesService.remove($stateParams.parentId, id).then(function () {
                  load()
                })
              })
            } else {
              CollectiblesService.remove($stateParams.parentId, id).then(function () {
                load()
              })
            }
          }
        },
      )
    })
  }

  vm.classDisabled = function () {
    if (vm.title === '' || vm.title === null || vm.title === undefined) {
      return 'is-disabled'
    } else {
      return
    }
  }

  vm.saveCollectible = function () {
    $('#myModal').modal('hide')
    $('#myModal').on('hidden.bs.modal', function () {
      CollectiblesService.save($stateParams.parentId, {
        t: vm.title,
        em: 2,
        'k-prod': vm.set['k-prod'],
        sho: true,
      }).then(function (result) {
        $state.go(
          'pub.collectibles.edit',
          { parentId: $stateParams.parentId, id: result.results.id },
          { reload: true },
        )
      })
    })
  }

  $('.showProduct').hide()

  vm.options = [
    { id: 1, t: 'Sticker' },
    { id: 2, t: 'Card' },
    { id: 3, t: 'Figure' },
  ]

  vm.listProductTypes = vm.options

  vm.publish = function (state, item) {
    if (state) {
      if (item.txt === '' || item.txt === undefined || item.txt === null) {
        swal('Need complete all fields required.', '', 'warning')
        return
      }

      CollectiblesService.publish(item.id).then(
        function () {
          item.st = 1
          swal('Published', '', 'success')
        },
        function (err) {
          var e = err.error.message.split(';')
          var html = ''
          for (var i = 0; i < e.length; i++) {
            html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
          }

          if (item.txt === '' || item.txt === undefined || item.txt === null) {
            html +=
              '<p style="color:red; font-size:14px; font-weigth:100;">Decription: non zero value required</p>'
          }

          swal({
            title: vm.nameType + ' Incomplete',
            text: html,
            html: true,
          })
        },
      )
    } else {
      CollectiblesService.unpublish(item.id).then(
        function () {
          item.st = false
          swal('Unpublished', '', 'success')
        },
        function (err) {
          var e = err.error.message.split(';')
          var html = ''
          for (var i = 0; i < e.length; i++) {
            html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
          }
          swal({
            title: vm.nameType + ' Incomplete',
            text: html,
            html: true,
          })
        },
      )
    }
  }

  vm.barConfig = {
    animation: 150,
    onEnd: function (/** ngSortEvent */ evt) {
      vm.orderList(evt)
    },
  }

  vm.orderList = function (evt) {
    for (var i = 0; i < vm.items.length; i++) {
      vm.items[i].o = parseInt(evt.newIndex) + 1
      if (vm.items[i].id === evt.model.id) {
        vm.update(evt.model)
      }
    }
  }

  vm.update = function (model) {
    CollectiblesService.update($stateParams.parentId, model.id, {
      n: model.o,
    }).then(function () {
      load()
    })
  }

  $('#myModal').on('shown.bs.modal', function () {
    $('#collectibleTitle').focus()
  })

  load()

  vm.sort = function (propertyName) {
    vm.sortReverse = !vm.sortReverse
    vm.sortType = propertyName
    vm.items = $filter('orderBy')(vm.items, vm.sortType, vm.sortReverse)
  }

  vm.shinies = function (item) {
    $state.go('pub.collectibles.shinies', {
      parentId: $stateParams.parentId,
      collectibleId: item.id,
    })
  }

  vm.editing = {}
  vm.bkpBC = null
  vm.editInline = function (item) {
    if ((vm.set.st === 0 || vm.set.st === 5) && (item.st === 0 || item.st === 4)) {
      item.edit = !item.edit
      vm.editing = item
      vm.bkpBC = item.bc
    } else {
      swal("You can't edit this collectible count", '', 'warning')
    }
  }

  vm.saveEdit = function (item) {
    CollectiblesService.update($stateParams.parentId, item.id, {
      bc: vm.editing.bc,
    }).then(function () {
      item.edit = false
      vm.editing = {}
      vm.bkpBC = null
    })
  }

  vm.collectiblesTranslations = []
  vm.translate = {}
  vm.pathImgTTranslation = ''
  vm.pathImgLTranslation = ''
  vm.pathImgBLTranslation = ''
  vm.pathImgQTranslation = ''
  vm.loadTTranslation = false
  vm.loadLTranslation = false
  vm.loadBLTranslation = false
  vm.loadQTranslation = false
  vm.translations = function (item) {
    vm.itemSelected = item
    loadTranslations()
    $('#modalTranslate').modal('show')
  }

  vm.translate = {}
  vm.addTranslate = function () {
    vm.translate = {}
    $('#modalTranslateAdd').modal('show')
  }

  function loadTranslations() {
    CollectiblesService.listTranslations(vm.itemSelected.id).then(function (result) {
      vm.collectiblesTranslations = result.results
    })
  }

  vm.classDisabled = function () {
    if (!vm.translate.comm || !vm.translate.t) {
      return 'is-disabled'
    } else {
      return
    }
  }

  vm.saveTranslate = function () {
    if (vm.translate.id) {
      vm.translate['id-q'] = vm.itemSelected.id
      CollectiblesService.updateTranslation(vm.translate.id, vm.translate).then(
        function () {
          loadTranslations()
          vm.translate = {}
          $('#modalTranslateAdd').modal('hide')
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    } else {
      vm.translate['id-q'] = vm.itemSelected.id
      CollectiblesService.createTranslation(vm.itemSelected.id, vm.translate).then(
        function () {
          loadTranslations()
          vm.translate = {}
          $('#modalTranslateAdd').modal('hide')
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    }
  }

  vm.editTranslate = function (id) {
    CollectiblesService.getTranlation(id).then(
      function (result) {
        vm.translate = result.results
        $('#modalTranslateAdd').modal('show')
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.deleteTranslate = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          CollectiblesService.removeTranslation(id).then(
            function () {
              loadTranslations()
              vm.translate = {}
              $('#modalTranslateAdd').modal('hide')
            },
            function (err) {
              $timeout(function () {
                swal(err.error.message, '', 'error')
              }, 500)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.uploadTTranslation = function (item) {
    vm.loadTTranslation = true
    UploadService.save('collectibles', vm.pathImgTTranslation, 'img-t', item.id).then(
      function (fileName) {
        vm.loadTTranslation = false
        item['img-t'] = fileName
      },
    )
  }

  vm.uploadLTranslation = function (item) {
    vm.loadLTranslation = true
    UploadService.save('collectibles', vm.pathImgLTranslation, 'img-l', item.id).then(
      function (fileName) {
        vm.loadLTranslation = false
        item['img-l'] = fileName
      },
    )
  }

  vm.uploadBLTranslation = function (item) {
    vm.loadBLTranslation = true
    UploadService.save('collectibles', vm.pathImgBLTranslation, 'img-b-l', item.id).then(
      function (fileName) {
        vm.loadBLTranslation = false
        item['img-b-l'] = fileName
      },
    )
  }

  vm.uploadQTranslation = function (item) {
    vm.loadQTranslation = true
    UploadService.save('collectibles', vm.pathImgQTranslation, 'qmf', item.id).then(function (fileName) {
      vm.loadQTranslation = false
      item['qmf'] = fileName
    })
  }

  vm.loadingPublishAll = false
  vm.publishAll = function () {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          vm.loadingPublishAll = true

          var promises = []

          for (var i = 0; i < vm.itemsAwaitingCount.length; i++) {
            promises.push(
              CollectiblesService.update($stateParams.parentId, vm.itemsAwaitingCount[i].id, {
                st: 0,
              }),
            )
          }

          for (var i = 0; i < vm.itemsDraft.length; i++) {
            promises.push(CollectiblesService.publish(vm.itemsDraft[i].id))
          }
          $q.all(promises).then(
            function () {
              if (vm.itemsAwaitingCount.length > 0) {
                var promises = []
                for (var i = 0; i < vm.itemsAwaitingCount.length; i++) {
                  promises.push(CollectiblesService.publish(vm.itemsAwaitingCount[i].id))
                }

                $q.all(promises).then(
                  function () {
                    vm.loadingPublishAll = false
                    load()
                  },
                  function (err) {
                    vm.loadingPublishAll = false
                    var e = err.error.message.split(';')
                    var html = ''
                    for (var i = 0; i < e.length; i++) {
                      html +=
                        '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
                    }

                    if (item.txt === '' || item.txt === undefined || item.txt === null) {
                      html +=
                        '<p style="color:red; font-size:14px; font-weigth:100;">Decription: non zero value required</p>'
                    }

                    swal({
                      title: vm.nameType + ' Incomplete',
                      text: html,
                      html: true,
                    })
                  },
                )
              } else {
                vm.loadingPublishAll = false
                load()
              }
            },
            function (err) {
              vm.loadingPublishAll = false
              var e = err.error.message.split(';')
              var html = ''
              for (var i = 0; i < e.length; i++) {
                html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
              }

              if (item.txt === '' || item.txt === undefined || item.txt === null) {
                html +=
                  '<p style="color:red; font-size:14px; font-weigth:100;">Decription: non zero value required</p>'
              }

              swal({
                title: vm.nameType + ' Incomplete',
                text: html,
                html: true,
              })
            },
          )
        }
      },
    )
  }

  vm.loadingDeleteAll = false
  vm.deleteAll = function () {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          vm.loadingDeleteAll = true

          var ids = []
          for (var i = 0; i < vm.itemsDraft.length; i++) {
            ids.push(vm.itemsDraft[i].id)
          }
          for (var i = 0; i < vm.itemsAwaitingCount.length; i++) {
            ids.push(vm.itemsAwaitingCount[i].id)
          }

          CollectiblesService.deleteAll({ ids: ids }).then(
            function () {
              vm.loadingDeleteAll = false
              load()
              toastr.success('done!')
            },
            function (err) {
              vm.loadingDeleteAll = false
              var e = err.error.message.split(';')
              var html = ''
              for (var i = 0; i < e.length; i++) {
                html += '<p style="color:red; font-size:16px; font-weigth:100;">' + e[i] + '</p>'
              }

              swal({
                title: 'Error',
                text: html,
                html: true,
              })
            },
          )
        }
      },
    )
  }

  vm.loadingClearCache = false
  vm.clearCache = function () {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          vm.loadingClearCache = true

          var ids = []
          for (var i = 0; i < vm.items.length; i++) {
            ids.push(vm.items[i].id)
          }

          CollectiblesService.clearCache({ ids: ids }).then(
            function () {
              vm.loadingClearCache = false
              toastr.success('done!')
              load()
            },
            function (err) {
              vm.loadingClearCache = false
              var e = err.error.message.split(';')
              var html = ''
              for (var i = 0; i < e.length; i++) {
                html += '<p style="color:red; font-size:16px; font-weigth:100;">' + e[i] + '</p>'
              }

              swal({
                title: 'Error',
                text: html,
                html: true,
              })
            },
          )
        }
      },
    )
  }
}
